import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LegacyAgency, LegacyGeographicArea, LegacyJurisdictionalUnit, LegacyProtectingUnit } from 'src/app/_models/reports/legacy';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root'
})
export class LegacyService {
  private baseURL = this.environment.commonUtilityApi.baseUrl + '/classicSearch/';

  constructor(private http: HttpClient, private environment: ConfigService) { }

  getLegacyGeographicAreas() {
    return this.http.get<LegacyGeographicArea[]>(this.baseURL + 'geographicAreas');
  }

  getLegacyJurisdictionalAgencies() {
    return this.http.get<LegacyAgency[]>(this.baseURL + 'agencies');
  }

  getLegacyJurisdictionalUnits() {
    return this.http.get<LegacyJurisdictionalUnit[]>(this.baseURL + 'jurisdictionalUnits');
  }

  getLegacyProtectingUnits() {
    return this.http.get<LegacyProtectingUnit[]>(this.baseURL + 'responsibleUnits');
  }
}
